/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ChallengeResolution,
  ChallengeResolution$inboundSchema,
} from "./challengeresolution.js";

export type ResolveChallengesResult = {
  /**
   * The created resolution records.
   */
  resolutions: Array<ChallengeResolution>;
};

/** @internal */
export const ResolveChallengesResult$inboundSchema: z.ZodMiniType<
  ResolveChallengesResult,
  unknown
> = z.object({
  resolutions: z.array(ChallengeResolution$inboundSchema),
});

export function resolveChallengesResultFromJSON(
  jsonString: string,
): SafeParseResult<ResolveChallengesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResolveChallengesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResolveChallengesResult' from JSON`,
  );
}
